import React from 'react';

import {
  defaultReportFilterConfig,
  IReportFilterConfig,
  TargetingCCPAAll,
} from '~/src/dash/api/console-api';
import { ECurrencyType } from '~/src/dash/api/exchange-rates';
import { IStore } from '~/src/dash/reducers/store';
import { isIntegralplatform } from '~/src/dash/resellers/utils/importResellerConfig';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { getTimezone } from '~/src/dash/utils/timezone';
import { BidderReportFormView } from '~/src/dash/views/bidder-report-form-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

export const BidderReportNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
  },
  function ({ session, user }: IProps) {
    const time = 'report-' + new Date().getTime();
    return (
      <BidderReportFormView
        report={{
          ID: '',
          CreatedAt: '',
          UpdatedAt: '',
          DeletedAt: '',

          Name: time,
          Active: 'false',
          Timezone: getTimezone(user.user.Timezone, session.publisher.Timezone),
          ReportType: isIntegralplatform() ? '25' : '2',
          SuperOnly: 1,
          Subject: time,
          Recipients: [],
          Frequency: '1',
          ScheduledDay: '1',
          Period: '1',
          Countries: [],
          SiteIDs: [],
          BidderIDs: [],
          BidderGroupsIDs: [],
          CampaignIDs: [],
          NetworkIDs: [],
          SegmentIDs: [],
          AdsourceIDs: [],
          Positions: [],
          DeviceEnvs: [],
          DeviceTypes: [],
          Adomains: '',
          DealIDs: '',
          BidderCodes: [],
          DemandTypes: [],
          Metrics: [],
          GroupByOptions: [],
          DMAs: '',
          States: [],
          StreamTypes: [],
          VenueIDs: '',
          ReportFilterConfig: { ...defaultReportFilterConfig } as IReportFilterConfig,
          CurrencyDisplayed: ECurrencyType.CURRENCY_TYPE_USD,
          TargetingCCPA: TargetingCCPAAll,
        }}
      />
    );
  },
);
